// extracted by mini-css-extract-plugin
export default {"checkboxesWrapper":"footer-module__checkboxesWrapper__ENhXz","buttonWithLoader":"footer-module__buttonWithLoader__Y-s75"};